import * as React from 'react'

function SvgHt(props) {
	return (
		<svg viewBox="0 0 500 300" width="1em" height="1em" {...props}>
			<path fill="#d21034" d="M0 0h500v300H0z" />
			<path fill="#00209f" d="M0 0h500v150H0z" />
			<g fill="#f1b517" stroke="#000" strokeWidth={0.183}>
				<path fill="#fff" stroke="none" d="M202.679 112.284h94.642v75.341h-94.642z" />
				<path
					fill="#016a16"
					stroke="#016a16"
					d="M269.047 166.766l-19.314.56-19.227.22s-9.878 3.653-13.916 4.473c-4.026.817-3.503 2.14-6.618 2.836-2.496.558-2.784.734-4.248.83-.886.058-1.977.74-3.045 1.49v10.45h94.642v-9.939c-1.026-.559-2.004-.944-3.004-1.284-1.39-.472-2.327-.99-4.823-1.547-3.115-.696-2.592-2.019-6.618-2.836-4.038-.82-13.829-5.253-13.829-5.253z"
				/>
				<g id="ht_svg__a">
					<path d="M244.529 143.512l1.397-.033 2.555 10.75-.545 3.385-3.407-14.102z" />
					<path fill="#fff" d="M243.064 136.346l.954 8.284 1.022-.066-1.976-8.218z" />
					<path d="M245.722 154.589l-4.293-11.538 1.601-.098 5.009 14.101-2.317-2.465z" />
					<path fill="#fff" d="M239.419 136.477l1.772 8.02h1.43l-3.202-8.02z" />
					<path d="M241.906 150.546l-2.521-5.424 1.09-.23 4.6 9.007-3.169-3.353z" />
					<path fill="#fff" d="M236.08 138.778l2.794 7.626h1.43l-4.224-7.626z" />
					<g>
						<path
							fill="#0a328c"
							d="M242.249 151.364l-11.436-12.484c-3.571 2.828-2.908 8.021-2.908 8.021l12.957 10.166 1.387-5.703z"
						/>
						<path
							fill="#d20014"
							d="M248.861 158.235l-8.483-8.594c-3.587.125-.741 5.48-.56 6.152l9.043 7.734v-5.292z"
						/>
						<path d="M248.139 156.757l-17.54-18.78-.684.483 18.561 20.622-.337-2.325zM229.586 136.772l-.385-.446.038-.891-3.619-2.303 1.617 3.64 1.232.223.385.446.732-.669z" />
						<path d="M227.738 138.11c.616-.743 1.348-1.486 2.657-2.192l1 1.45-2.155 1.82-1.502-1.078z" />
						<path
							fill="#0a328c"
							stroke="#0a328c"
							d="M225.811 141.278l.588 1.026c.364-.135 4.031-3.457 4.031-3.457l2.632-.08.756-.838c-1.932-2.08-3.752.297-3.752.297l-4.255 3.052z"
						/>
						<path
							fill="#d20014"
							stroke="#d20014"
							d="M227.911 143.007c.14-.918 1.876-3.214 2.128-3.295 1.303.391 2.515 1.141 3.835-1.837-1.148 1.459-3.471-.027-3.471-.027l-1.008.838.028.405-3.052 2.836 1.54 1.08z"
						/>
					</g>
					<g>
						<path
							fill="#0a328c"
							d="M237.252 154.672l-14.367-11.411c-2.46 2.503-.415 10.231-.415 10.231l14.043 7.608.739-6.428z"
						/>
						<path
							fill="#d20014"
							d="M249.166 163.917l-11.818-9.467c-4.036.566-.864 6.506-.623 7.16l12.481 6.77-.04-4.463z"
						/>
						<path d="M248.697 162.005l-25.554-19.182-.587.591 26.837 20.955-.696-2.364zM221.928 141.807l-.46-.374-.122-.885-3.979-1.662 2.248 3.314 1.254.014.459.374.6-.781z" />
						<path d="M220.349 143.433c.473-.835 1.06-1.689 2.222-2.603l1.246 1.259-1.795 2.153-1.673-.809z" />
						<path
							fill="#0a328c"
							stroke="#0a328c"
							d="M218.925 146.641l.16 1.06c.337-.188 3.56-3.726 3.56-3.726l2.586-.477.527-.833c-1.797-2.114-3.713.698-3.713.698l-3.12 3.278z"
						/>
						<path
							fill="#d20014"
							stroke="#d20014"
							d="M220.971 148.545c-.123-.982 1.22-3.863 1.455-3.98 1.547.46 2.894 1.152 3.462-2.07-.897 1.614-3.46.363-3.46.363l-.86.979.121.53-2.61 3.37 1.892.808z"
						/>
					</g>
					<g>
						<path
							fill="#0a328c"
							d="M236.224 161.651c-.19-.046-18.517-10.442-18.517-10.442-1.334 2.252-.128 5.52.457 6.029.034 1.5-.602 2.306.707 5.439.386 2.036 1.328 3.913 2.7 5.027 1.671 6.417 8.222 6.848 10.746 1.624l3.907-7.677z"
						/>
						<path
							fill="#d20014"
							d="M248.352 168.512l-12.548-7.355c-4.036.567.085 8.056.326 8.71l12.116 4.304.106-5.659z"
						/>
						<path d="M246.243 165.846l-28.35-15.089-.484.672 29.905 16.647-1.071-2.23zM216.528 149.937l-.514-.3-.265-.856-4.2-1.04 2.758 2.934 1.24-.177.515.301.466-.862z" />
						<path d="M215.232 151.782c.332-.896.773-1.828 1.772-2.907l1.436 1.056-1.425 2.398-1.783-.547z" />
						<path
							fill="#0a328c"
							stroke="#0a328c"
							d="M214.1 155.181l.593 1.167c.307-.232 3.004-4.578 3.004-4.578l2.492-.82.469-1.014c-2.002-1.85-3.498 1.342-3.498 1.342l-3.06 3.903z"
						/>
						<path
							fill="#d20014"
							stroke="#d20014"
							d="M216.772 156.836c-.2-.999.484-4.197.7-4.345 1.56.465 2.863.597 3.223-2.622-.907 1.529-3.328.953-3.328.953l-.71 1.085.15.38-2.059 3.95 2.024.599z"
						/>
					</g>
				</g>
				<use xlinkHref="#ht_svg__a" transform="matrix(-1 0 0 1 499.859 0)" />
				<path
					fill="#016a16"
					stroke="#016a16"
					d="M248.757 125.603l-.465 9.07h2.9l-.425-8.992 3.023-.424-.335-3.582-7.51.29.041 3.253 2.771.385z"
				/>
				<g id="ht_svg__b" fill="#016a16">
					<path d="M249.817 121.898c-7.764-7.771-13.878-3.98-15.334-2.902.963.187 1.826-.412 2.273-.48-.28.353-.865 1.229-.865 1.229s2.4-1.134 2.668-1.03c-.346.276-.727.936-.727.936.178.069 1.528-1.057 1.795-1.077-.411.466-.539 1.528-.539 1.528l1.17-.545c.304.216-.085.63.18.609 1.944-.16 4.677 1.777 5.053 2.372" />
					<path d="M247.895 123.321c-.81-1.854-15.588-5.005-18.56.244 1.164.293 2.276-.976 2.276-.976l-.101 1.171 1.972-1.512-.708 1.56 1.568-1.268-.05 1.269 1.921-2.098-.253 1.22 1.72-.732-.203 1.024" />
					<path d="M247.238 123.614c-3.793-2.537-9.66-.83-9.66-.83-3.741 2.099-5.736 1.72-6.22 5.611.355-.146 1.366-1.366 1.366-1.366l.759 1.513.252-2.147.607 1.659.91-2.732.203 1.854 1.416-1.854.657.536.607-1.415.556.927s.961-.585 1.518-.244l1.062-1.22.252.879.91-1.073.355.78.91-.83-.05.586 3.135.05" />
					<path d="M246.38 124.053c-2.643-.05-10.226 2.812-12.188 5.806a13.29 13.29 0 011.263-.635l.387 1.203.473-1.203.1.927c.29-.724.618-.806 1.164-.049l.202-1.122.304 1.073.505-1.17s.318 1.269.506 1.22c0 0 .838-2.195 1.214-2.294l.1 1.366.506-1.366.456 1.025.1-1.464.506 1.122s.266-1.103.658-1.317l.758.683 3.378-2.427" />
					<path d="M246.888 124.678c-3.521 1.35-6.67 6.179-6.43 8.226 1.565-1.941 1.229-1.674 1.928.56 0 0 .264-1.955.53-2.187l.459 1.446.17-1.892.47.022-.12-1.187.7.535c-.164-.678-.339-.907.385-1.489 0 0-.917.117-.193-1.535l.675.651s-.12-.721.12-1l2.485-.861" />
					<path d="M247.229 125.04l-1.33 2.534.682.197-1.535 1.152 1.296-.132s-1.978.724-2.217 2.665l2.013-.888s-1.706 1.744-1.945 2.797l1.16-1.02s-1.125 1.217-.955 3.06l.853-.954c-.205 2.237-.137 2.435.887 4.146 0 0-.273-2.633.034-2.962l2.25 2.337-1.261-3.324s1.398 2.106 2.25 1.909l-1.773-2.698 1.74 1.414-1.978-2.961 1.841.56s-1.33-1.679-1.228-2.732l1.262 1.382s-.477-1.58-.34-2.04l.647.132-1.262-1.448.853-.165-.102-.954.614-.197-.034-1.053M248.559 125.797c-2.183 2.961-1.057 7.535-2.353 9.871" />
				</g>
				<use xlinkHref="#ht_svg__b" transform="matrix(-1 0 0 1 499.859 0)" />
				<path d="M250.945 166.535s1.189-9.945 1.186-14.225c-.002-3.37-.814-10.835-.814-10.835H247.9s-.52 7.429-.442 10.789c.1 4.281 1.186 14.27 1.186 14.27h2.301z" />
				<path d="M247.674 141.953h3.96l-.465-2.666h-2.87l-.625 2.666z" />
				<path d="M247.927 139.816h3.539l-.667-2.666h-2.18l-.692 2.666z" />
				<path d="M248.155 137.655h2.949l-.499-2.666h-1.876l-.574 2.666z" />
				<path d="M250.709 134.673h-2.063l-.209.964h2.44l-.168-.964zM251.132 164.367h-2.62M251.275 162.42h-2.94M251.664 160.444h-3.727M251.856 158.291h-3.9M251.883 156.139h-4.102M252.043 154.171h-4.45M252.053 152.38h-4.65M252.025 150.219h-4.65M251.87 148.084h-4.495M251.664 145.914h-4.065M251.467 143.955h-3.672" />
				<g>
					<path
						fill="#0a328c"
						stroke="#0a328c"
						d="M249.909 119.044c-.688-.324-2.245-1.313-1.783-1.903l.713-1.214c1.01-2.277-.018-1.395-.126-2.106-.103-.682 3.865-.149 3.924 1.397.016.426-.295.176-.252 2.611l-.755 1.458c-.565.053-1.234-.014-1.721-.243z"
					/>
					<path d="M250.392 124.934l-.986-.83.273-7.105.965.283-.252 7.652z" />
					<path
						fill="#d20014"
						stroke="#d20014"
						d="M251.672 119.246c.62-.362 1.024-1.443.65-2.085-1.016-1.287-1.673-.756-3.378-1.336-.34.362-1.055 1.059-.902 1.579 2.242 1.056 1.372.156 2.114.288.4.07.658.545 1.516 1.554z"
					/>
				</g>
				<g>
					<use xlinkHref="#ht_svg__c" transform="matrix(1 0 0 -1 -.002 320.37)" />
					<path
						fill="#016a16"
						stroke="#fff"
						strokeWidth={0.181}
						strokeLinecap="round"
						d="M238.358 161.75c0 1.299-.815 2.353-1.818 2.353s-1.819-1.054-1.819-2.353v-1.276h3.637v1.276z"
					/>
					<ellipse
						fill="#fff"
						cx={236.539}
						cy={160.063}
						rx={1.806}
						ry={0.898}
						stroke="none"
					/>
					<path
						fill="#016a16"
						stroke="#f1b517"
						d="M236.126 161.075l-.31-3.297h1.382l-.226 3.297h-.846z"
					/>
					<path
						id="ht_svg__c"
						fill="#016a16"
						stroke="#fff"
						strokeWidth={0.237}
						strokeLinecap="round"
						d="M238.538 160.118c-.265.493-1.06.852-1.999.852-.938 0-1.728-.359-1.993-.852a.756.756 0 00-.099.359c0 .669.937 1.21 2.092 1.21s2.092-.541 2.092-1.21a.748.748 0 00-.093-.359z"
					/>
					<g id="ht_svg__d">
						<path d="M246.035 172.786l-7.06-2.19-3.076-5.254-10.893-.535.378 3.94 9.28 1.777.882 1.581 10.666 2.968-.177-2.287z" />
						<path
							fill="#503200"
							d="M238.662 174.254l-11.149-16.398-.547.411 11.06 16.467.636-.48z"
						/>
						<path
							fill="#fff"
							d="M228.551 158.5l-1.19-1.992c-.223-.368-.561-.49-1.059-.228-.484.255-.437.76-.24 1.123l1.101 1.852 1.388-.755z"
						/>
						<path d="M239.986 164.127l-22.496-2.286-.547 3.27 22.387 2.252.656-3.236z" />
						<path d="M217.089 160.997l-.583 4.538h.948l.656-4.151-1.021-.387zM220.844 161.735l-.255 4.08.583.07.474-3.622-.802-.528zM236.085 163.494l-.547 3.834 1.094-.035.437-3.799h-.984zM239.436 163.599l-.779 4.434 1.238.18.354-2.332c.1.468.531.824 1.046.824.589 0 1.07-.464 1.07-1.032s-.481-1.026-1.07-1.026c-.409 0-.78.24-.94.687l.231-1.662-1.15-.073zM231.317 164.319l-3.094 3.482.361.423 3.97-2.711-1.237-1.194zM224.124 173l3.094-3.482-.361-.423-3.97 2.711 1.237 1.194zM232.22 172.129l-3.764-2.91-.387.273 2.965 3.756 1.186-1.119zM222.938 165.413l3.816 2.81.464-.348-2.99-3.755-1.29 1.293zM227.09 163.094l.365 4.573.513-.022 1.207-4.452-2.085-.099zM228.341 174.189l-.365-4.573-.565-.053-.691 4.626h1.621zM233.401 168.026l-4.795.51-.073.457 4.85.634.018-1.601zM221.993 169.609l4.68-.74.1-.364-4.842-.54.062 1.644z" />
						<ellipse cx={227.693} cy={168.548} rx={1.27} ry={1.225} />
						<path
							fillRule="evenodd"
							strokeLinecap="round"
							d="M234.438 168.548c0 3.592-3.022 6.507-6.745 6.507-3.723 0-6.745-2.915-6.745-6.507 0-3.592 3.022-6.507 6.745-6.507 3.723 0 6.745 2.915 6.745 6.507zm-1.347 0c0 2.874-2.419 5.207-5.398 5.207s-5.398-2.333-5.398-5.207c0-2.874 2.419-5.207 5.398-5.207s5.398 2.333 5.398 5.207z"
						/>
						<path d="M223.48 165.264l-1.057-.796M231.034 164.493l.902-.92M232.967 172.701l-1.109-.87M223.48 173.696l.954-1.02" />
						<g>
							<path d="M246.196 162.122l1.155 5.886-.942.497-1.014-6.299.801-.084z" />
							<path
								fill="#fff"
								d="M245.592 161.364c-.535-.224-1.232.155-2.374-1.292-1.878 1.723-.107 1.98.179 3.686.53.218.858-1.323 2.302-1.481.179-.018 2.298-.203 2.298-.203l-.532-.726s-1.474.04-1.873.016z"
							/>
							<path
								fill="#fff"
								d="M246.359 162.518l-.214-1.756c-.232-.62-1-.087-1 .275l.197 1.619 1.017-.138z"
							/>
						</g>
						<path
							fillRule="evenodd"
							d="M240.765 167.372l.019 1.637c-.536.183-.454.585-.437 1.168l.019 4.772c-.19.316-.778.331-1.054.58-.277.247-.242.729 1.02 1.046l.975.035c1.486-.325 1.793-.818 1.048-1.095-.397-.148-.919-.324-1.117-.557l.033-1.137.964.035c.26 0 .753-.652.77-1.185l.005-2.47c-.035-1.401-1.085-1.559-1.38-1.542l.021-1.29-.886.003zm1.63 2.73c.018-.4-.555-.757-.786-.767s-.734.467-.751.867v1c.034.367.327 1.61.915 1.701.28.043.64-.4.64-.767l-.017-2.034z"
						/>
						<g fill="#fff">
							<path d="M234.275 172.328c-.636-.257-.63 1.172-.63 1.172l1.002.01c.44.2.792.843.512 1.159-.231.261-2.177-.441-2.308-.037.344 1.941 2.917 2.688 3.848 1.839.91-.83 1.141-3.048-1.817-3.629l-.607-.514zM234.87 172.856l-.292.639" />
						</g>
						<g>
							<path d="M214.943 173.055l-.963-4.05M216.112 172.822l-1.48-3.153M218.658 171.993l-3.337-1.792M220.103 171.628l-6.192-2.688" />
							<path
								fill="#d20014"
								stroke="#d20014"
								d="M210.215 166.013s-2.254-.036-2.656.122c-.162.064.567.825.416 1.115-.563 1.083-4.394.934-4.697.698-.519-.405 3.568-.753 3.595-1.029.03-.316-.605-1.146-.506-1.655.128-.661 1.788-.907 1.788-.907l2.06 1.656z"
							/>
							<path
								fill="#503200"
								d="M213.233 168.05l-5.102-4.222s-.225-.238-.413-.033c-.184.2.069.431.069.431l5.263 4.348.183-.524z"
							/>
							<path d="M218.146 172.217c-.09-.087-4.155-3.608-4.155-3.608l-.271-1.028s-.628.425-.858.645-.587.819-.587.819l1.138.052 3.595 3.294 1.138-.174z" />
						</g>
						<g>
							<ellipse cx={232.534} cy={177.056} rx={0.74} ry={0.715} />
							<ellipse cx={230.641} cy={175.716} rx={0.74} ry={0.715} />
							<ellipse cx={228.091} cy={176.593} rx={0.74} ry={0.715} />
							<ellipse cx={224.153} cy={177.445} rx={0.74} ry={0.715} />
							<ellipse cx={222.487} cy={177.64} rx={0.74} ry={0.715} />
							<ellipse cx={220.846} cy={177.64} rx={0.74} ry={0.715} />
							<ellipse cx={219.18} cy={177.591} rx={0.74} ry={0.715} />
							<ellipse cx={219.988} cy={176.325} rx={0.74} ry={0.715} />
							<ellipse cx={221.604} cy={176.398} rx={0.74} ry={0.715} />
							<ellipse cx={223.144} cy={176.203} rx={0.74} ry={0.715} />
							<ellipse cx={222.361} cy={174.961} rx={0.74} ry={0.715} />
							<ellipse cx={220.846} cy={174.937} rx={0.74} ry={0.715} />
						</g>
						<path
							fillRule="evenodd"
							d="M236.47 177.991c0-.316-.769-.18-.769-.55 0-.412 1.173-.11 1.335.252.66-.596.944-.16 1.348.02.575-.855 1.287-.823 1.981-.197.401-.443 1.41-.297 1.757.197.664-.66 1.255-.497 1.715-.02.186-.346.458-.27.654-.02.354-.628 1.242-.44 1.616-.024.332-.366.673-.08 1.114.19.297-.28.778-.227.778.05 0 .29-.628.188-.628.474 0 .256.458.127.458.45 0 .255-.68.35-.785-.056-.23.44-1.062.271-1.144-.138-.276.335-.897.436-1.246-.059-.286.234-.63.267-.787.031-.517.556-1.388.442-1.688-.17l-.294.012c-.508.69-1.302.37-1.52-.01-.853.615-1.362.42-1.838.02-.548.666-1.381.62-1.573 0-.368.267-1.137.33-1.137.017 0-.301.653-.192.653-.469zm1.655.15c0 .143-.195.26-.436.26s-.435-.117-.435-.26.195-.26.435-.26.436.117.436.26zm1.82-.218c0 .172-.235.312-.524.312-.289 0-.524-.14-.524-.312 0-.173.235-.312.524-.312.29 0 .524.14.524.312zm3.575.197c0 .175-.212.316-.474.316s-.474-.141-.474-.316c0-.174.212-.316.474-.316s.474.142.474.316zm-1.904-.083c0 .22-.207.4-.463.4s-.464-.18-.464-.4.208-.4.464-.4.463.18.463.4zm4.06.01c0 .198-.186.358-.414.358s-.415-.16-.415-.358c0-.197.186-.357.415-.357s.414.16.414.357zm-1.244.083c0 .128-.12.231-.267.231-.148 0-.268-.103-.268-.23s.12-.231.268-.231c.147 0 .267.103.267.23zm2.422.094c0 .183-.135.331-.302.331s-.301-.148-.301-.331c0-.183.135-.332.301-.332s.302.149.302.332z"
						/>
					</g>
					<use xlinkHref="#ht_svg__d" transform="matrix(-1 0 0 1 499.859 0)" />
					<g strokeWidth={0.231}>
						<path
							fill="#0a328c"
							stroke="#0a328c"
							d="M249.837 165.718c-2.512 0-4.55.944-4.55 2.102 0 .199.057.39.169.572.543.629 2.307 1.087 4.398 1.087 1.957 0 3.625-.402 4.277-.97.164-.216.256-.446.256-.689 0-1.158-2.038-2.102-4.55-2.102z"
						/>
						<path
							strokeWidth={0.187}
							d="M254.427 167.981v7.058c0 .828-2.048 1.5-4.572 1.5s-4.573-.672-4.573-1.5v-7.058c0 .828 2.049 1.5 4.573 1.5 2.524 0 4.572-.672 4.572-1.5z"
						/>
						<path
							fill="#d20014"
							stroke="#d20014"
							strokeWidth={0.183}
							d="M245.282 167.982v1.082l2.22 6.845 1.772-5.264 1.946 5.465 1.425-5.159 1.783 3.469v-1.92l-1.656-3.363a8.25 8.25 0 01-.593.134l-1.028 3.812-1.447-3.604a14.522 14.522 0 01-.715-.023l-1.453 3.627-1.661-4.367c-.376-.217-.593-.466-.593-.734z"
						/>
						<path
							fill="#0a328c"
							stroke="#0a328c"
							strokeWidth={0.187}
							d="M254.427 173.721v1.318c0 .827-2.048 1.499-4.572 1.499s-4.573-.672-4.573-1.5v-1.317c0 .828 2.049 1.5 4.573 1.5 2.524 0 4.572-.672 4.572-1.5z"
						/>
						<path
							strokeWidth={0.187}
							d="M251.737 175.085c-.372.055-.769.097-1.185.118l.011 1.317a12.24 12.24 0 001.186-.118l-.012-1.317zM246.868 174.855l-.012 1.312c.353.1.75.185 1.186.246v-1.317a8.907 8.907 0 01-1.174-.241zM245.282 173.723v1.317c0 .246.185.474.506.679l.023-1.3c-.336-.21-.529-.444-.529-.696zM254.428 173.863l-.023.006c-.08.267-.379.516-.831.723l.006 1.312c.53-.245.848-.54.848-.863v-1.178z"
						/>
						<path
							fill="none"
							strokeWidth={0.187}
							d="M254.427 168.027v7.012c0 .828-2.048 1.5-4.572 1.5s-4.573-.672-4.573-1.5v-7.012"
						/>
						<path
							fill="#fff"
							stroke="#fff"
							strokeWidth={0.192}
							d="M253.392 167.52c0 .501-1.584.907-3.537.907-1.954 0-3.538-.406-3.538-.907s1.584-.907 3.538-.907c1.953 0 3.537.406 3.537.907z"
						/>
						<path d="M248.698 168.19l.157 1.25c.307.022.626.038.953.04l.232-1.29h-1.342zM252.801 167.887l-.912.247.058 1.177c.31-.053.602-.117.866-.19l-.012-1.234zM247.397 165.979c-.259.076-.5.165-.72.263l.127.945.581-.185.012-1.023zM249.837 165.606c-.122 0-.241.007-.36.011l.197 1.183.605-.012.238-1.154a9.727 9.727 0 00-.68-.028zM252.51 166.024l-.122 1.034.691.244.076-1.015a5.259 5.259 0 00-.645-.263z" />
						<path
							strokeWidth={0.183}
							d="M245.993 168.8l.184-1.288-.935-.506.028 1.465.723.329zM254.396 168.522l.042-1.288-.876.262.834 1.026z"
						/>
					</g>
					<g>
						<path d="M263.686 160.029c.83-.115 2.062 1.024 2.136 2.433.06 1.118-1.69 1.06-1.69 1.06-.09.458-1.055.881-1.84.916-.763.033.207-1.432.207-1.432-.475-1.26.148-2.748.148-2.748l1.039-.229z" />
						<path d="M262.499 162.948l.801-.029s.061.414.208.43c.157.017.326-.401.326-.401l1.217-.029" />
						<path
							fill="#d20014"
							stroke="#f1b517"
							d="M264.131 160.859c.68-.491.084-1.48-.386-1.489l-1.098.029c-.517.01-1.392.573-1.276 1.06.102.423.387.617.831.543.202-.033.626-.563.831-.572.275-.013.878.588 1.098.429z"
						/>
					</g>
					<path
						fillRule="evenodd"
						d="M214.242 174.855c-.617.078-.731.788-.5 1.44-2.686.756-5.086 1.74-7.455 2.406-.095-.474 1.174-1.845 1.174-1.845.336.162.587.93.587.93.084-1.578 1.639-2.628 1.639-2.628-.924-.122-3.732.967-4.068 1.412 0 0 1.087-.121 1.255 0 0 0-2.14 2.312-2.237 3 .333.75 4.027 1.311 4.027 1.311-.058.195-1.087.93-1.087.93 1.47.323 3.685-.717 4.347-1.35 0 0-1.728-.143-3.074-1.234 0 0 .277.68.11 1.004 0 0-2.1-.605-2.318-.953.006-.03 4.966-1.315 7.368-2.001.088.429.565 1.24 1.138 1.048.374-.125.256-.866.117-1.39a.77.77 0 00.505.185c.422 0 .767-.327.767-.735 0-.407-.345-.74-.767-.74a.757.757 0 00-.72.505c-.096-.453-.345-1.354-.808-1.295zm1.889 1.528c0 .19-.16.345-.358.345s-.358-.155-.358-.345.16-.345.358-.345.358.154.358.345z"
					/>
					<g>
						<path d="M293.068 177.884c.183-.367-.162-2.212-.162-2.212-.373.042-.882.681-.882.681.48-1.511-.865-4.037-.865-4.037.91.19 3.945 3.128 4.103 3.657 0 0-1.33-.474-1.53-.415.217 1.506 1.258 2.205 1.65 2.988 0 0-1.726.38-1.553 1.822l-1.127.021c-.39-.481.152-1.276.152-1.276l-7.739-3.241c-.499-.21-1.62-.718-1.452-1.318.17-.604 2.016.251 2.47.398l6.935 2.932z" />
						<path d="M285.635 176.541l.91-1.673c.326-.44-.346-.92-.823-.356l-1.02 1.527c-.454.837.5 1.067.933.502z" />
					</g>
				</g>
				<g>
					<g fill="#fff">
						<path d="M231.367 180.366l-.063-1.825-2.207.122-.126 1.987 2.396-.284z" />
						<path d="M215.237 182.924l-2.95-1.655c12.168 1.115 14.653-3.13 17.593-3.356 1.808-.141 2.09 2.002-1.412.982l.905 2.241s-8.638 4.86-17.129 2.853l2.993-1.065zM268.249 180.366l.063-1.825 2.7.062.125 1.988-2.888-.225z" />
						<path d="M284.939 182.477l2.777-1.515c-13.94.415-10.766-2.29-17.74-3.048-1.802-.196-3.156 2.12 1.413.982l-.906 2.241 2.193.002c4.748 3.127 11.156 3.406 15.401 2.402l-3.138-1.064z" />
						<path d="M228.418 178.908v3.154s7.728 2.868 21.519 2.868c13.85 0 21.519-2.868 21.519-2.868v-3.154s-5.85 2.695-21.52 2.695c-15.61 0-21.518-2.695-21.518-2.695z" />
					</g>
					<path
						fill="#000"
						d="M229.573 182.08l.682-2.31.317.088-.602 2.037 1.18.324-.081.272-1.496-.411zm2.236-1.015l.038-.454.102-.39.338.083-.102.389-.193.416-.183-.045zm3.326-.156l.322.063-.286 1.36c-.05.236-.118.418-.203.546s-.208.222-.371.281c-.164.059-.363.065-.598.019a1.217 1.217 0 01-.536-.224.66.66 0 01-.242-.391c-.032-.156-.021-.359.031-.608l.287-1.36.323.064-.287 1.358c-.043.204-.055.358-.036.463s.07.192.156.264a.73.73 0 00.335.147c.237.047.418.028.54-.056.123-.084.216-.273.278-.569l.287-1.357zm.363 2.51l.402-2.37.333.053.975 2.064.315-1.86.312.048-.402 2.37-.333-.052-.975-2.066-.315 1.862-.312-.05zm2.541.383l.342-2.378.326.044-.342 2.378-.326-.044zm.937-1.049c.047-.396.194-.694.441-.893.247-.2.545-.28.894-.242.228.025.427.1.598.226.171.125.293.287.367.486.074.199.097.418.069.656a1.382 1.382 0 01-.23.633c-.123.18-.283.308-.48.386a1.279 1.279 0 01-.619.081 1.202 1.202 0 01-.604-.231 1.056 1.056 0 01-.364-.49 1.31 1.31 0 01-.071-.612zm.337.042c-.034.288.02.523.16.706.14.183.332.288.574.315a.814.814 0 00.638-.184c.178-.15.286-.377.322-.684a1.19 1.19 0 00-.041-.52.761.761 0 00-.259-.37.83.83 0 00-.427-.168.865.865 0 00-.625.164c-.185.135-.3.382-.342.741zm2.309 1.417l.202-2.394.337.027 1.144 1.982.16-1.88.314.026-.203 2.393-.337-.027-1.143-1.983-.16 1.88-.314-.024zm3.489.242l.109-2.399 1.677.071-.013.283-1.348-.057-.034.743 1.167.05-.013.282-1.167-.049-.049 1.09-.329-.014zm1.833.079l1.004-2.383.355.007.97 2.42-.375-.008-.275-.732-1.041-.02-.288.722-.35-.007zm.738-.973l.844.016-.247-.67a6.39 6.39 0 01-.166-.501 2.98 2.98 0 01-.143.456l-.288.7zm1.914 1.01l.005-2.4h.33l-.006 2.401h-.33zm1.542-.006l-.031-2.118-.82.011-.004-.283 1.972-.027.004.283-.823.012.031 2.117-.33.005zm2.442-.058l-.116-2.398.329-.015.102 2.115 1.225-.055.014.283-1.554.07zm1.675-.073l.776-2.46.354-.025 1.193 2.325-.374.026-.343-.705-1.038.071-.22.744-.348.024zm.644-1.033l.841-.058-.308-.645a6.445 6.445 0 01-.213-.485c-.02.156-.053.312-.1.467l-.22.721zm2.921.758l-.273-2.386 1.67-.178.032.282-1.342.143.084.739 1.161-.124.033.282-1.161.123.124 1.085-.328.034zm1.825-1.37c-.058-.394.006-.718.193-.972.186-.253.453-.404.8-.452.228-.031.44-.007.64.073.197.08.358.207.482.38.123.175.203.381.238.62.035.24.017.463-.056.667s-.194.368-.365.491c-.17.123-.362.2-.576.23a1.221 1.221 0 01-.646-.077 1.085 1.085 0 01-.48-.386 1.327 1.327 0 01-.23-.574zm.337-.041c.043.286.156.5.34.644a.817.817 0 00.637.164.8.8 0 00.57-.333c.133-.188.178-.435.132-.741a1.201 1.201 0 00-.176-.493.781.781 0 00-.347-.295.842.842 0 00-.458-.058.85.85 0 00-.561.311c-.144.176-.19.443-.137.8zm2.614.806l-.444-2.363 1.085-.19a1.52 1.52 0 01.51-.023.558.558 0 01.315.177.673.673 0 01.169.338.586.586 0 01-.09.453c-.09.135-.25.239-.48.31a.87.87 0 01.218.084c.11.067.22.157.328.267l.547.569-.407.071-.417-.435a4.647 4.647 0 00-.295-.284c-.075-.065-.14-.108-.194-.13s-.108-.033-.16-.036a1.065 1.065 0 00-.182.02l-.376.066.197 1.049-.324.057zm.076-1.377l.696-.122c.148-.026.262-.06.34-.105a.367.367 0 00.189-.398.358.358 0 00-.178-.254c-.098-.057-.238-.07-.42-.038l-.774.136.147.781zm3.93-.262l.34.01c-.007.269-.083.49-.227.66a1.034 1.034 0 01-.595.34c-.262.058-.487.053-.675-.015s-.347-.189-.478-.365a1.606 1.606 0 01-.275-.6 1.366 1.366 0 01-.004-.67c.054-.203.16-.37.316-.503s.341-.223.556-.27c.243-.053.46-.037.654.046a.973.973 0 01.464.428l-.3.141a.757.757 0 00-.332-.32.693.693 0 00-.431-.028.813.813 0 00-.438.231.689.689 0 00-.183.405 1.39 1.39 0 00.029.466c.046.2.117.367.212.502a.686.686 0 00.358.273c.144.046.29.052.439.02.18-.039.32-.122.422-.25.101-.126.15-.293.149-.5zm.916.653l-.67-2.312 1.734-.467.079.273-1.416.381.205.708 1.326-.357.078.272-1.326.357.228.787 1.472-.396.079.273-1.79.481z"
						stroke="none"
					/>
				</g>
			</g>
		</svg>
	)
}

export default SvgHt
